import React from 'react';
import { isIOS, isSafari } from 'react-device-detect';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PortraitPaperLayout from '../@common/portrait/PortraitPaperLayout';
import PageLines from '../@common/PageLines';
import { LargePageLineText } from '../@common/PageLineText';
import BaseInput from '../@common/BaseInput';
import GroupedPageLines from '../@common/GroupedPageLines';
import NameAndDateLines from '../@common/NameAndDateLines';
import { determineStyleBasedOnLineWidth, getFontSize } from 'utils/style-utils';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);
const sectionTexts = [...Array(3).keys()];
const pageLines = [...Array(3).keys()];

const SequenceGraphicOrganizer = ({ onChange, isCursive, isNarrow, valueMap, printRef }) => {
  const bookFont = isCursive ? 'Cursive-Book' : 'Print-Wide-Book';
  const marginTop = determineStyleBasedOnLineWidth(isCursive, isNarrow, {
    cursiveAndNarrow: isIOS || isSafari ? '-20px' : '-26px',
    narrow: '-15px',
    cursive: isIOS || isSafari ? '-27px' : '-36px',
    regular: '-24px'
  });
  const fontSize = getFontSize(isCursive, isNarrow);

  const marginTopInput = determineStyleBasedOnLineWidth(isCursive, isNarrow, {
    cursiveAndNarrow: isSafari || isIOS ? '12px' : '0px',
    narrow: isIOS ? '6px' : '5px',
    cursive: isSafari || isIOS ? '6px' : '-10px',
    regular: '-6px'
  });

  const classes = useStyles({ marginTopInput, isNarrow });
  const bodyMarginTop = isNarrow ? '-20px' : '-30px';

  return (
    <PortraitPaperLayout isNarrow={isNarrow} printRef={printRef}>
      <NameAndDateLines
        isCursive={isCursive}
        fontFamily={bookFont}
        isNarrow={isNarrow}
        top={5}
        width={775}
      />
      <PageLines width={775} className={classes.pageLine} isNarrow={isNarrow}>
        <LargePageLineText className={classes.pageLineText}>
          <BaseInput
            // eslint-disable-next-line
            onChange={({ target }) => onChange({ [1]: target.value })}
            showBackground={true}
            fontSize={fontSize}
            fontFamily={bookFont}
            color="#000"
            placeholder={
              isCursive && !isNarrow ? t('enterTopicOrTitle') : t('enterNarrativeTitleTopic')
            }
            className={classes.input}
            maxLength={45}
            value={valueMap[1]}
          />
        </LargePageLineText>
      </PageLines>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: bodyMarginTop,
          alignItems: 'center'
        }}
      >
        {sectionTexts.map((x, index) => {
          const first = t('first');
          const next = t('next');
          const last = t('last');
          const sections = [first, next, last];
          const sectionName = sections[index];
          return (
            <div key={sectionName}>
              <GroupedPageLines
                top={25}
                width={775}
                fontSize={fontSize}
                color="black"
                marginLeftText={15}
                marginTopText={marginTop}
                fontFamily={bookFont}
                isNarrow={isNarrow}
              >
                {sectionName},
              </GroupedPageLines>
              {pageLines.map((pageLine, idx) => {
                // removes line from last section
                if (index + 1 === sectionTexts.length && idx + 1 === pageLines.length) {
                  return null;
                }
                return (
                  <GroupedPageLines
                    key={pageLine}
                    top={isNarrow ? 20 : 25}
                    width={775}
                    fontFamily={bookFont}
                    isNarrow={isNarrow}
                  />
                );
              })}
              {index + 1 < sectionTexts.length && (
                <div
                  className="thickGrayLine"
                  style={{
                    borderBottom: '4px solid darkGray',
                    padding: isNarrow ? '30px 0 0 0' : '20px 0 0 0',
                    width: '775px',
                    marginLeft: '25px',
                    marginBottom: isNarrow ? '25px' : '0px'
                  }}
                />
              )}
            </div>
          );
        })}
      </Box>
    </PortraitPaperLayout>
  );
};

const useStyles = makeStyles(isNarrow => ({
  pageLine: {
    alignSelf: 'center !important',
    justifyContent: 'center',
    margin: '130px 25px 0px 25px !important',
    position: 'relative',
    top: '-50px !important',
    left: '0px !important'
  },
  pageLineText: {
    justifyContent: 'space-between !important',
    width: '514px !important',
    marginLeft: '20px !important',
    fontSize: '30px !important',
    marginTop: '-26px !important'
  },
  input: ({ marginTopInput }: any) => ({
    width: '775px !important',
    marginLeft: '-20px !important',
    paddingLeft: '10px',
    marginTop: `${marginTopInput} !important`,
    color: 'black'
  })
}));
export default SequenceGraphicOrganizer;
